<template>
  <div
    id="traceability-alert-modal"
    class="traceability-alert-modal"
  >
    <modal
      ref="traceabilityAlertModal"
      template="neutral"
      title="Minha Rotina (Inclusão & Exclusão de Exames)"
      ref-name="traceabilityAlertModal"
      :icon-enabled="false"
      :close-button-enabled="false"
      class="traceability-alert-modal"
    >
      <button class="traceability-alert-modal__timer-button">
        <span v-if="showTimer && timer > 0">{{ timer }}</span>
        <svg
          v-if="!showTimer || timer === 0"
          class="icon"
          viewBox="0 0 24 24"
          @click="closeTraceabilityAlertModal()"
        >
          <title>Fechar modal sobre minha rotina</title>
          <g
            fill="none"
            stroke="currentColor"
            stroke-miterlimit="10"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="3"
              y1="3"
              x2="21"
              y2="21"
            />
            <line
              x1="21"
              y1="3"
              x2="3"
              y2="21"
            />
          </g>
        </svg>
      </button>

      <p>
        Prezado cliente,
        <br />
        Conheça a nova funcionalidade "Minha Rotina" que vai otimizar seu dia a dia.
        <br />
        Siga o passo-a-passo conforme vídeo e em caso de dúvidas, por favor entre em
        contato.
      </p>

      <md-layout
        class="new"
        md-flex="100"
      >
        <video
          width="800"
          controls
          preload="metadata"
          @loadedmetadata="onVideoLoaded"
        >
          <source
            src="https://storageapoiob2bprd.blob.core.windows.net/dashboard/Minha_rotina.mp4"
            type="video/mp4"
          />
          Seu navegador não suporta vídeos em HTML5. Atualize para uma versão mais
          recente.
        </video>
      </md-layout>

      <div class="traceability-alert-modal__actions">
        <md-button
          class="btn btn-primary"
          @click="goNow()"
        >
          Conhecer agora
        </md-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Moment from 'moment'
import { TRACEABILITY_SEARCH_DATE } from '@/enums'

export default {
  name: 'TraceabilityAlert',
  props: {
    showTimer: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      firstTimeAtNewDashboard: false,
      timer: 15,
      intervalId: null,
      openTimer: null,
    }
  },
  watch: {
    showTimer(newVal) {
      if (newVal) {
        this.timer = 15
        this.iniciarTimer()
      } else {
        this.timer = 0
        clearInterval(this.intervalId)
      }
    },
  },
  mounted() {
    if (this.showTimer) {
      this.iniciarTimer()
      this.checkIfShouldShowAlert()
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
    clearTimeout(this.openTimer)
  },
  methods: {
    onVideoLoaded(event) {
      const video = event.target
      video.currentTime = 5
    },
    openTraceabilityAlertModal() {
      this.$refs.traceabilityAlertModal.open()
    },
    openTraceabilityAlertModalWithoutTimer() {
      this.timer = 0
      if (this.openTimer) {
        clearTimeout(this.openTimer)
        this.openTimer = null
      }
      const today = new Date().toDateString()
      localStorage.setItem('traceabilityAlertLastShown', today)
      this.$refs.traceabilityAlertModal.open()
    },
    closeTraceabilityAlertModal() {
      this.$refs.traceabilityAlertModal.close()
      const today = new Date().toDateString()
      localStorage.setItem('traceabilityAlertLastShown', today)
      this.$emit('modal-closed')
    },
    checkIfShouldShowAlert() {
      if (this.$route.path !== '/traceability/search') {
        return
      }

      const lastShown = localStorage.getItem('traceabilityAlertLastShown')
      const today = new Date().toDateString()

      if (lastShown === today) {
        return
      }

      this.openTimer = setTimeout(() => {
        this.openTraceabilityAlertModal()
      }, 10000)
    },
    iniciarTimer() {
      if (!this.showTimer) return

      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this.intervalId)
        }
      }, 1000)
    },
    goNow() {
      this.closeTraceabilityAlertModal()
      this.$router.push({
        path: '/traceability/search',
        query: {
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
          startDate: Moment(new Date()).clone().subtract(7, 'days').format('DD/MM/YYYY'),
          endDate: Moment(new Date()).format('DD/MM/YYYY'),
        },
      })
    },
  },
}
</script>

<style lang="scss">
.traceability-alert-modal {
  font-family: 'Exo 2', sans-serif !important;

  &__timer-button {
    width: 40px;
    height: 40px;
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 1041;
    background-color: #7f1a55;
    display: flex;
    flex-shrink: 0;
    border-radius: 50%;
    outline: none;
    transition: all ease 0.2s;
    padding: 0;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: 'Exo 2', sans-serif !important;
    font-weight: 300;

    svg {
      display: block;
      margin: auto;
      width: 20px;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }

  &__footer {
    font-size: 14px;
    align-items: center;
  }

  .md-dialog {
    width: 810px;
    max-height: 90%;

    .size-medium .md-dialog {
      min-height: 140px;
    }

    .standard-modal__container-dismiss {
      margin-top: 12px;
    }

    .standard-modal__title {
      font-weight: 300;
      font-size: 34px;
      line-height: 26px;
      color: #7f1a54;
      font-family: 'Exo 2', sans-serif !important;
    }

    p {
      font-size: 14px;
      line-height: 20px;
      color: #7a7a7a;
    }

    .new {
      display: flex;
      flex-direction: column;
    }

    hr {
      border: 1px solid #d8d8d8;
      margin: 12px 0;
    }
  }

  video {
    margin-top: 12px;
  }
}

#traceabilityAlertModal {
  z-index: 1000;
}
</style>
